<template>
  <div>
    <anli v-if="show"></anli>
    <CaseDetailCommon v-else></CaseDetailCommon>
  </div>
</template>
<script>
import anli from "./anli.vue"
import CaseDetailCommon from "./CaseDetailCommon.vue"
export default{
  components:{
    anli,
    CaseDetailCommon
  },
  watch:{
    '$route.query.id':function(newVal,oldVal){
      if(newVal){
        this.show=false
      }else{
        this.show=true
      }
    }
  },
  data(){
    return{
     show:true
    } 
  },
  mounted(){
    if(this.$route.query.id){
      this.show=false
    }else{
      this.show=true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TypicalCase.vue